angular.module('jv.Admin.Users.Ajax.Factory', ['App.ajax.service'])
    .factory('prepareAjaxCall', ['makeAjaxCall', function (makeAjaxCall) {
        var headerTypesMap= {
            json: {'Content-Type':'application/json; charset=UTF-8'},
            form: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
        };
        return function(args, options, onSuccess, onError){
            onSuccess = (onSuccess || angular.noop);

            if(options['headerType']) {
                args.headers = headerTypesMap[options['headerType']];
            }
            var requestObj = args || {};
            requestObj.ajaxtype = options.ajaxtype;
            requestObj.url = options.url;
            requestObj.requestType = options.requestType || "GET";
            requestObj.cache = options.cache || false;
            var requestPromise = makeAjaxCall(requestObj);

            requestPromise.then(function(results) {
                onSuccess(results.data,results.status);
            }, function(results) {
                if(onError){
                    onError(results.data, results.status);
                }
            });
        };
    }]);
